import {createContext, useEffect, useState, useMemo} from "react";
import axios from "axios";
import {Config, languageOptions} from "../config/Config";
import Loading from "../bricks/Loading";
import adminTranslations from "../assets/administration-translations.json";

export const TranslationContext = createContext();

export const TranslationProvider = ({children}) => {
    const getBrowserLang = useMemo(() => {
        if (localStorage.getItem('language')) {

            const lang = localStorage.getItem("language");
            if (languageOptions.hasOwnProperty(lang)) {
                return localStorage.getItem("language");
            } else {
                localStorage.removeItem("language");
            }
        }
        const nav = window.navigator;
        const browserLang = nav.language || nav.userLanguage;
        return Config.browserLanguageMap[browserLang] || "cs";
    }, []);

    const [translations, setTranslations] = useState({});
    const [data, setData] = useState(null);
    const [language, setLanguage] = useState(getBrowserLang);
    const [languages, setLanguages] = useState(null);
    const [isLoading, setIsLoading] = useState(true);


    // Předformátovat admin překlady při inicializaci
    const formattedAdminTranslations = useMemo(() => {
        const formatted = {};
        Object.entries(adminTranslations).forEach(([code, langMap = {}]) => {
            Object.entries(langMap).forEach(([lang, value]) => {
                (formatted[lang] ||= {});
                formatted[lang][code] = value;
            });
        });
        return formatted;
    }, []);


    useEffect(() => {
        const fetchTranslations = async () => {
            try {
                const response = await axios.get(`/public/translations.json?t=${new Date().getTime()}`);
                const fetchedData = response.data;

                // Merge s admin překlady
                for (let lang in formattedAdminTranslations) {
                    fetchedData[lang] = {
                        ...fetchedData[lang],
                        ...formattedAdminTranslations[lang]
                    };
                }
                setData(fetchedData);
                setLanguages(Object.keys(fetchedData));
            } catch (error) {
                console.error('Failed to fetch translations:', error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchTranslations();
    }, [formattedAdminTranslations]);

    useEffect(() => {
        if (data) {
            setTranslations(data[language]);
        }
    }, [language, data]);

    const contextValue = useMemo(() => ({
        translations,
        language,
        setLanguage,
        languages,
        rawTranslations: data
    }), [translations, language, languages, data]);

    return (
        <TranslationContext.Provider value={contextValue}>
            {isLoading ? <Loading/> : children}
        </TranslationContext.Provider>
    );
};